import React, { useEffect, useState } from 'react'
import BookingCalendar from './BookingCalendar'
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { message } from 'antd';
import dayjs from "dayjs";
import axiosInstance from '../../../utils/axiosInstance';
;

dayjs.extend(utc);
dayjs.extend(timezone);



// Example Usage
const availableData = {}; // Optional



const ScheduleMeeting=()=> {
  const [unavailableData, setUnavailableData] = useState({});

  const getDate=async()=>{
    try {
        const response = await axiosInstance.get(`/calendar/blocked-slots/`);
        setUnavailableData(response.data.blocked_slots);
    } catch (error) {
           message.error(error.response.data.error);
    }
  }
  useEffect(()=>{
    getDate()
  },[]);

  return (
    <div className='m-0'>
      <BookingCalendar
        availableData={availableData}
        unavailableData={unavailableData}
      />
   </div>
  )
}
export default ScheduleMeeting